module.exports = __webpack_public_path__ + "static/media/main-hatching-failed.28a9e28c.mp3";